$(document).on('turbo:load', () => {

    let $input = $('.searchbar input');
    if ($input.length) {
        let val = $input.val();
        $input.val('');
        $input.trigger('focus').val(val);
    }

    let $form = $('form.search-and-filter');
    if ($form.length) {
        let $resetButton = $form.find('input[type="reset"]');
        $resetButton.on('click',(e) => {
            e.preventDefault();
            let select_options = $form.find('select option');
            select_options.removeAttr('selected');
            $form.trigger('reset');
            $form.find('input[type="text"]').val('');
            $form.find('input[type="hidden"]').val('');
            $form.find('input[type="checkbox"]').prop('checked', false);
            $form.find("#filters_date_selection").trigger('change');
            $input.trigger('focus')
        });
    }

    $form.find('input[type="date"]').prop('disabled', true);

    let $dateSelect = $form.find("#filters_date_selection");
    $dateSelect.on("change", (e)=>{
        //   @ts-ignore
        if (e.currentTarget.value == ""){
            //Add timeout to allow time for data-reveal to trigger
            setTimeout(()=>{
                $form.find('input[type="date"]').prop('disabled', true);

            }, 200);
        }

    });

    let $filingYearSelect = $('select#filters_filing_year.organization');
    if ($filingYearSelect.length) {
        $filingYearSelect.on('change', (event) => {
            $(event.target).closest('form').trigger('submit');
        })
    }



});